import { render } from "./SingleCasesStudyThree.vue?vue&type=template&id=49a7b084&scoped=true"
import script from "./SingleCasesStudyThree.vue?vue&type=script&lang=js"
export * from "./SingleCasesStudyThree.vue?vue&type=script&lang=js"

import "./SingleCasesStudyThree.vue?vue&type=style&index=0&id=49a7b084&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a7b084"]])

export default __exports__